import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ricerca-ispettorati',
  templateUrl: './ricerca-ispettorati.component.html',
  styleUrls: ['./ricerca-ispettorati.component.scss']
})
export class RicercaIspettoratiComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [this.search?.nome],
      codice: [this.search?.codice],
      compagnia: [this.search?.compagnia],
      via: [this.search?.via],
      civico: [this.search?.civico],
      comune: [this.search?.comune],
      tel: [this.search?.tel],
      fax: [this.search?.fax],
      cell: [this.search?.cell],
      email: [this.search?.email],
    });

    this.form.valueChanges.subscribe(() => this.searchChange.emit(this.form.value));

  }

}
